<template>
  <section v-if="!isLoading" class="pass-analytics">
    <h2 class="dashboard__tab-title">My Analytics</h2>
    <h5 class="dashboard__tab-sub-title">
      Current month vs previous month
    </h5>
    <StatCards :stats="cardStats" />
    <MinutesWatchedChart
      v-if="formattedChart && Object.keys(formattedChart).length > 1"
      :data="getChartData()"
    />
    <TrainingHistory :isLoading="isLoadingCourses" />
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import StatCards from '@/components/user-dashboard/pass-analytics/StatCards.vue'
import MinutesWatchedChart from '@/components/user-dashboard/pass-analytics/MinutesWatchedChart.vue'
import TrainingHistory from '@/components/user-dashboard/pass-analytics/TrainingHistory.vue'
export default {
  name: 'PassAnalytics',
  components: {
    StatCards,
    MinutesWatchedChart,
    TrainingHistory,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoadingCourses: false,
      page_size: 10,
    }
  },
  computed: {
    ...mapState({
      monthlyStats: state => state.statistics.monthlyStats,
      yearlyStats: state => state.statistics.yearlyStats,
      lastMonthStats: state => state.statistics.lastMonthStats,
      activeCourses: state => state.courses.activeCourses,
    }),
    ...mapGetters({
      formattedChart: 'statistics/formattedChart',
    }),
    cardStats() {
      const { courses_viewed, time_watched, videos_watched } = this.yearlyStats
      const { time_watched: monthly_time_watched } = this.monthlyStats
      let data = {}
      data = {
        totalCourses: {
          label: 'Courses viewed',
          currentMonth: courses_viewed?.value ?? 0,
          lastMonth: this.lastMonthStats.courses_viewed?.value ?? 0,
        },
        totalTime: {
          label: 'Total time watched',
          currentMonth: this.getTimeValue(time_watched?.value),
          lastMonth:
            this.getTimeValue(this.lastMonthStats.time_watched?.value) ?? 0,
        },
        numVideosWatched: {
          label: 'Videos viewed',
          currentMonth: videos_watched?.value ?? 0,
          lastMonth: this.lastMonthStats.videos_watched?.value ?? 0,
        },
        monthTimeWatched: {
          label: 'Watched this month',
          currentMonth: this.getTimeValue(monthly_time_watched?.value),
          lastMonth:
            this.getTimeValue(
              this.lastMonthStats.monthly_time_watched?.value
            ) ?? 0,
        },
      }
      return data
    },
    chartMonths() {
      return this.formattedChart.map(month => month.month)
    },
    chartMonthsLabel() {
      return this.formattedChart.map(month => month.monthLabel)
    },
    chartValues() {
      return this.formattedChart.map(month => Math.floor(month.value / 60))
    },
  },
  async created() {
    await this.getAllStats()
    this.setIsComponentLoading(false)
  },
  methods: {
    ...mapActions({
      getMonthlyStats: 'statistics/getMonthlyStats',
      getYearlyStats: 'statistics/getYearlyStats',
      getLastMonthStats: 'statistics/getLastMonthStats',
      getActiveCourses: 'courses/getActiveCourses',
      getTrainingHistory: 'content/getTrainingHistory',
      setIsComponentLoading: 'app/setIsComponentLoading',
    }),

    getChartData() {
      let chartData = {
        values: this.chartValues,
        months: this.chartMonths,
        monthsLabel: this.chartMonthsLabel,
        labels: {},
      }
      chartData = {
        ...chartData,
        labels: {
          title: 'Minutes Watched',
          yAxes: 'Number of Minutes Watched',
          xAxes: 'Minutes watched for each month over the last year.',
        },
      }
      return chartData
    },
    async getAllStats() {
      const promises = [
        this.getMonthlyStats(),
        this.getYearlyStats(),
        this.getTrainingForHistory(),
        this.getLastMonthStats(),
        this.getActiveCourses(),
      ]
      await Promise.allSettled(promises)
    },
    async getTrainingForHistory() {
      try {
        this.isLoadingCourses = true
        await this.getTrainingHistory({
          type: 'course',
          status: ['in_progress', 'completed'],
        })
      } catch (error) {
        this.isLoadingCourses = false
      } finally {
        this.isLoadingCourses = false
      }
    },
    getTimeValue(time) {
      const value = time ?? 0
      if (value > 0 && value < 60) return 1
      return value / 60
    },
  },
}
</script>
